import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const SEARCH_BUSINESS_INITIAL: any = {
  search: "",
  searchResults: [],
};

const searchBusinessSlice = createSlice({
  name: "searchBusiness",
  initialState: {
    ...SEARCH_BUSINESS_INITIAL,
  },
  reducers: {
    SEARCH_BUSINESS_UPDATE: (
      state,
      action: PayloadAction<{
        data?: any;
        prop?: string;
        value?: string | Number | Object | [];
      }>,
    ) => {
      // console.log("SEARCHING", action.payload);
      return (state = {
        ...state,
        ...(action.payload.data ? action.payload.data : null),
        ...(action.payload.prop ? { [action.payload.prop]: action.payload.value } : null),
      });
    },
  },
});

const { SEARCH_BUSINESS_UPDATE } = searchBusinessSlice.actions;

export { searchBusinessSlice, SEARCH_BUSINESS_INITIAL, SEARCH_BUSINESS_UPDATE };
